const initialState = {
  discounts: [],
};

const discount = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_DISCOUNTS":
      return {
        ...state,
        discounts: action.payload,
      };
    default:
      return state;
  }
};

export default discount;
